(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-marquee')) {
    class TDMarquee extends HTMLElement {
      SIZE_MULTIPLIER = 2;
      MAX_COPIES = 20;

      constructor() {
        super();
        this._isDragging = false;
        this._handleResize = this.debounce(this.rebuildMarquee.bind(this), 200);
      }

      connectedCallback() {
        this.wrapper = this.querySelector('[data-td-marquee-wrapper]');
        this.content = this.querySelector('[data-td-marquee-content]');
        this.items = this.querySelector('[data-td-marquee-items]');
        this.enableSwipe = this.dataset.enableSwipe === 'true';
        this.setAttribute('data-td-ready', 'false');

        if (!this.wrapper || !this.content || !this.items) return;

        window.addEventListener('resize', this._handleResize);

        if (this.enableSwipe) {
          this._handlePointerDown = this.handlePointerDown.bind(this);
          this.addEventListener('pointerdown', this._handlePointerDown);
        }

        this.observeVisibility();
        requestAnimationFrame(() => this.rebuildMarquee());
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this._handleResize);
        if (this._handlePointerDown) this.removeEventListener('pointerdown', this._handlePointerDown);
        
        this._cleanupObserver();

        if (this._dragController) {
          this._dragController.abort();
        }
      }

      _cleanupObserver() {
        if (this._visibilityObserver) {
          this._visibilityObserver.disconnect();
          this._visibilityObserver = null;
        }
      }

      observeVisibility() {
        this._visibilityObserver = new IntersectionObserver(
          (entries) => {
            // Safety: check if observer still exists during async callback
            if (!this._visibilityObserver || !entries[0].isIntersecting) return;

            this.querySelectorAll('img[loading="lazy"]').forEach((img) => {
              img.removeAttribute('loading');
            });

            this._cleanupObserver(); 
          },
          { rootMargin: '200px' }
        );
        this._visibilityObserver.observe(this);
      }

      rebuildMarquee() {
        if (!this.wrapper || !this.content || !this.items) return;
        if (this._isDragging) return;
        this.resetTrackCopies();
        const copies = this.calculateCopies();
        this.addTrackCopies(copies);
        this.duplicateContent();
        this.setDuration(copies);
        this.setAttribute('data-td-ready', 'true');
        this.restartAnimation();
      }

      calculateCopies() {
        const viewportWidth = this.getBoundingClientRect().width;
        const itemWidth = this.items.getBoundingClientRect().width;
        if (viewportWidth <= 0 || itemWidth <= 0) return 1;

        const requiredCopies = Math.ceil((viewportWidth * this.SIZE_MULTIPLIER) / itemWidth);
        return Math.max(1, Math.min(requiredCopies, this.MAX_COPIES));
      }

      resetTrackCopies() {
        this.removeContentClone();
        Array.from(this.content.children).forEach((child, index) => {
          if (index > 0) child.remove();
        });
      }

      addTrackCopies(copies) {
        for (let i = 1; i < copies; i++) {
          const clone = this.items.cloneNode(true);
          clone.removeAttribute('data-td-marquee-items');
          clone.setAttribute('aria-hidden', 'true');
          this.content.appendChild(clone);
        }
      }

      removeContentClone() {
        this.wrapper.querySelector('[data-td-marquee-clone]')?.remove();
      }

      duplicateContent() {
        this.removeContentClone();
        const clone = this.content.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-td-marquee-clone', '');
        this.wrapper.appendChild(clone);
      }

      setDuration(copies) {
        const baseSpeed = parseFloat(getComputedStyle(this).getPropertyValue('--td-marquee-speed')) || 10;
        const duration = Math.max(baseSpeed, Math.sqrt(copies) * baseSpeed);
        this.style.setProperty('--td-marquee-duration', `${duration}s`);
      }

      restartAnimation() {
        const animations = this.wrapper.getAnimations();
        requestAnimationFrame(() => {
          animations.forEach((animation) => {
            animation.currentTime = 0;
          });
        });
      }

      getTranslateX(element) {
        const transform = getComputedStyle(element).transform;
        if (!transform || transform === 'none') return 0;
        const matrix = transform.match(/matrix.*\((.+)\)/);
        return matrix?.[1] ? parseFloat(matrix[1].split(', ')[4]) || 0 : 0;
      }

      getTrackDistance() {
        const style = getComputedStyle(this);
        const gap = parseFloat(style.getPropertyValue('--td-inline-spacing')) || 0;
        return (this.content?.offsetWidth || 0) + gap;
      }

      getAnimationDurationMs(animation) {
        const duration = animation?.effect?.getComputedTiming?.().duration;
        return Number.isFinite(duration) ? duration : 0;
      }

      getActiveAnimation() {
        return this.wrapper?.getAnimations()?.[0] || null;
      }

      normalizeProgress(value) {
        return ((value % 1) + 1) % 1;
      }

      handlePointerDown(event) {
        if (event.button !== 0 || this._isDragging) return;
        if (!this.wrapper || !this.content) return;

        this._startX = event.clientX;
        this._startY = event.clientY;
        this._dragController = new AbortController();
        this._dragAnimation = null;
        this._dragDuration = 0;
        this._dragDistance = 0;
        this._dragStartProgress = 0;
        this._dragFallbackX = 0;

        const onPointerMove = (e) => {
          const dx = e.clientX - this._startX;
          const dy = e.clientY - this._startY;

          if (!this._isDragging && Math.abs(dx) > 5) {
            if (Math.abs(dy) > Math.abs(dx)) {
              this._dragController?.abort();
              return;
            }

            this._isDragging = true;
            this.classList.add('is-dragging');
            this._dragAnimation = this.getActiveAnimation();
            this.wrapper.style.animationPlayState = 'paused';

            if (this._dragAnimation) {
              this._dragDuration = this.getAnimationDurationMs(this._dragAnimation);
              this._dragDistance = this.getTrackDistance();
              if (this._dragDuration > 0) {
                const animationTime = Number(this._dragAnimation.currentTime) || 0;
                this._dragStartProgress = this.normalizeProgress(animationTime / this._dragDuration);
              }
            } else {
              this._dragFallbackX = this.getTranslateX(this.wrapper);
            }

            try { this.setPointerCapture(e.pointerId); } catch {}
          }

          if (this._isDragging) {
            e.preventDefault();

            if (this._dragAnimation && this._dragDuration > 0 && this._dragDistance > 0) {
              const directionFactor = this.dataset.direction === 'reverse' ? 1 : -1;
              const progress = this.normalizeProgress(this._dragStartProgress + (dx * directionFactor) / this._dragDistance);
              this._dragAnimation.currentTime = progress * this._dragDuration;
              return;
            }

            this.wrapper.style.transform = `translateX(${this._dragFallbackX + dx}px)`;
          }
        };

        const onPointerUp = (e) => {
          this._dragController?.abort();
          if (!this._isDragging) return;
          try { this.releasePointerCapture(e.pointerId); } catch {}
          this._isDragging = false;
          this.classList.remove('is-dragging');
          this.wrapper.style.transform = '';
          this.wrapper.style.animationPlayState = '';

          this._dragAnimation = null;
          this._dragDuration = 0;
          this._dragDistance = 0;
          this._dragStartProgress = 0;
        };

        document.addEventListener('pointermove', onPointerMove, {
          signal: this._dragController.signal,
          passive: false,
        });
        document.addEventListener('pointerup', onPointerUp, { signal: this._dragController.signal });
        document.addEventListener('pointercancel', onPointerUp, { signal: this._dragController.signal });
      }

      debounce(func, delay) {
        let timeout;
        return (...args) => {
          clearTimeout(timeout);
          timeout = setTimeout(() => func.apply(this, args), delay);
        };
      }
    }
    customElements.define('td-marquee', TDMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
